export enum PendingReason {
    None = 0,
    CreditHold = 1,
    EngineeringReview = 2,
    WindLoadReview = 4,
    CustomerServiceReview = 8,
    AddressReview = 16
}

export const PendingReasonMetadata = {
    '0': {
        display: 'None',
        value: 0
    },
    '1': {
        display: 'Credit Hold',
        value: 1
    },
    '2': {
        display: 'Engineering',
        value: 2
    },
    '4': {
        display: 'Wind Load',
        value: 4
    },
    '8': {
        display: 'Customer Service',
        value: 8
    },
    '16': {
        display: 'Address',
        value: 16
    }
}